import http from '@/requests/http'

class MessageManagement {
  static allReceivedHistory (params) {
    return http.post('message-management/received-history', params)
  }
  static allSentHistory (params) {
    return http.post('message-management/sent-history', params)
  }
  static getNotification (params) {
    return http.post('message-management/notification', params)
  }
  static readNotification (params) {
    return http.post('message-management/read-notification', params)
  }
  static store (params) {
    return http.post('message-management/store', params)
  }
  static async destroy (id) {
    return http.post(`message-management/delete/${id}`)
  }
}

export default MessageManagement
